import React, { useEffect, useState } from 'react';
import * as HELPER from '../config/helper';
import { PAGE_NUMBER, ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';
import FullPageLoader from '@common/FullPageLoader';
import FinancierService from '@src/services/FinancierService';
import FinanciersTable from './financiers/FinanciersTable';
import { FinancierApiResponse } from './financiers/financiers.interface';
import AddEditFinancier from './financiers/AddEditFinancier';
import { toast } from 'react-toastify';


export default function FinancierManagement(): ReturnType<React.FC> {
    let [loading, setLoading] = useState<boolean>(false);
    let [showAddFinancier, setShowAddFinancier] = useState<boolean>(false)
    let [financierResponse, setFinancierResponse] = useState<FinancierApiResponse>({
        status: STATUS_SUCCESS,
        message: '',
        data: [],
        pagination: {
            total: 0,
            limit: 10,
            pages: 0,
            cur_page: 1,
            prev_page: false,
            next_page: false,
        },
    });

    useEffect(() => {
        getFinanciersList();
    }, [])

    /**
     * Fetches the list of financiers with optional pagination parameters.
     * 
     * @param {Object} [params] - Optional parameters for the API request.
     * @param {number} [params.page_number] - The page number to fetch. Defaults to 1 if not provided.
     * @returns {Promise<void>} - A promise that resolves when the financier list is fetched and state is updated.
     */
    const getFinanciersList = async (params?: { page_number: number }): Promise<void> => {
        try {
            setLoading(true);
            let filters = {
                page_number: params?.page_number ?? PAGE_NUMBER
            }
            const value = await FinancierService.getFianciersListing(filters);
            setFinancierResponse(value?.data ?? {});            
        } catch (error) {
            toast.error("Error fetching financiers list");
            console.error("Error fetching financiers list", error);            
        } finally {
            setLoading(false);
        }
       
    }

    const handleLoader = (input: boolean) => {
        setLoading(input)
    }

    const showModalAddFinancier = () => {
        setShowAddFinancier(showAddFinancier => !showAddFinancier);
    }

    return (
        <div className="container-fluid">
            <div className="top-heading financer-lead-heding">
                <h1>Financier Management</h1>
                {HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_partner_management'], accessType: 'edit' }) && <button className="btn-line" onClick={showModalAddFinancier}>
                    <i className="ic-add"></i>
                    <span>Add Financier</span>
                </button>}
            </div>

            <FullPageLoader show={loading} />
            <FinanciersTable apiResponse={financierResponse} loading={loading} handleLoader={handleLoader} getFinanciersList={getFinanciersList}/>
            <AddEditFinancier callFrom={'AddFinancier'} showAddFinancier={showAddFinancier} showModalAddFinancier={showModalAddFinancier} 
                handleLoader={handleLoader} getFinanciersList={getFinanciersList}/>

        </div>
    )
}

